import React, { useState } from "react";
import { Formik, Form } from "formik";
import styled from "styled-components";
import { Input, Button, Modal } from "components/bootstrap";
import BootstrapModalWrapper from "components/bootstrap/BootstrapModalWrapper";
import ModalSubmit from "components/common/ModalSubmit";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { ForwardersActions } from "../stores/ForwardersStore";
const StyledButton = styled(Button)`
  vertical-align: top;
`;
const ForwarderForm = ({ forwarder, buttonBsStyle = "info", buttonBsSize = null, onSave = () => {
} }) => {
  const [showModal, setShowModal] = useState(false);
  const sendTelemetry = useSendTelemetry("input-profile");
  const _openModal = () => setShowModal(true);
  const _closeModal = () => setShowModal(false);
  const _updateForwarder = (title = forwarder.title, description = forwarder.description, inputProfileId = forwarder.input_profile_id) => {
    const updatedForwarder = {
      input_profile_id: inputProfileId,
      title,
      description,
      hostname: forwarder.hostname
    };
    ForwardersActions.update(forwarder.id, updatedForwarder).then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_UPDATED, {
        app_pathname: "forwarder"
      });
    });
  };
  const handleSubmit = (values) => {
    _updateForwarder(values.title, values.description, forwarder.input_profile_id);
    onSave();
    _closeModal();
  };
  const modalTitle = "Update forwarder";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: buttonBsStyle, bsSize: buttonBsSize, onClick: _openModal }, "Edit"), /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal, onHide: _closeModal, bsSize: "lg" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: { title: forwarder.title, description: forwarder.description, hostname: forwarder.hostname },
      onSubmit: handleSubmit
    },
    ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "title",
        name: "title",
        label: "Title",
        type: "text",
        value: values.title,
        onChange: handleChange,
        help: "Meaningful name used to identify this forwarder.",
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "description",
        name: "description",
        label: "Description",
        type: "text",
        value: values.description,
        onChange: handleChange,
        help: "Description for this forwarder "
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "hostname",
        name: "hostname",
        label: "Hostname",
        type: "text",
        disabled: true,
        value: values.hostname,
        onChange: handleChange,
        help: "The hostname of this forwarder"
      }
    )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        onCancel: _closeModal,
        isSubmitting,
        isAsyncSubmit: true,
        submitButtonText: "Update forwarder",
        submitLoadingText: "Updating forwarder..."
      }
    )))
  )));
};
export default ForwarderForm;
